class AuthStateManager {
  private isAuthInitialized = false;
  private authInitPromise: Promise<void> | null = null;
  private resolveAuthInit: (() => void) | null = null;

  constructor() {
    this.authInitPromise = new Promise((resolve) => {
      this.resolveAuthInit = resolve;
    });
  }

  setAuthInitialized(): void {
    if (!this.isAuthInitialized) {
      this.isAuthInitialized = true;
      if (this.resolveAuthInit) {
        this.resolveAuthInit();
      }
    }
  }

  isInitialized(): boolean {
    return this.isAuthInitialized;
  }

  async waitForAuthInit(): Promise<void> {
    if (this.isAuthInitialized) {
      return Promise.resolve();
    }
    return this.authInitPromise!;
  }

  reset(): void {
    this.isAuthInitialized = false;
    this.authInitPromise = new Promise((resolve) => {
      this.resolveAuthInit = resolve;
    });
  }
}

export const authStateManager = new AuthStateManager();
